import { useQuery } from 'react-query';
import { useAuth } from '../../hooks/auth';
import getBuildFormUrlencodedParams from '../../utils/getBuildFormUrlencodedParams';
import iflexApi from '../iflexApi';

export type Filial = {
  campo: string;
  cnpj_fil: string;
  cpf_fil: string;
  descricao: string;
  empresa_fil: string;
  id_fil: string;
  nome_fil: string;
  tipo_fil: string;
};

type GetFiliaisResponse = {
  filiais: Filial[];
};

async function getFiliais(userId: string): Promise<GetFiliaisResponse> {
  const data = getBuildFormUrlencodedParams({
    action: 'listarFiliais',
    controller: 'Filial',
    id_usr: userId,
  });

  return '';
  const response = await iflexApi.post('', data);

  return {
    filiais: response.data.rows,
  };
}

export function useFiliais() {
  const { user } = useAuth();
  return useQuery(['filiais'], () => getFiliais(user.id), {
    staleTime: 1000 * 5,
  });
}
